import type { AdyenAccount } from '../services/api';

export const ADYEN_KYC_BADGE: Record<string, string> = {
  passed: 'bg-success',
  in_review: 'bg-info',
  pending: 'bg-warning text-dark',
  failed: 'bg-danger'
};

export const ADYEN_KUNDKANNEDOM_LABEL: Record<string, string> = {
  passed: 'Godkänd',
  in_review: 'Under granskning',
  pending: 'Ej påbörjad',
  failed: 'Åtgärd krävs'
};

export const capabilityIsValid = (value: unknown): boolean => {
  if (!value || typeof value !== 'object') return false;
  const capability = value as { allowed?: unknown; verificationStatus?: unknown; status?: unknown };
  return capability.allowed === true || capability.verificationStatus === 'valid' || capability.status === 'valid';
};

export const isMockAdyenOnboardingUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;
  try {
    return new URL(url, window.location.origin).hostname === 'mock.adyen.local';
  } catch {
    return url.includes('mock.adyen.local');
  }
};

const hasLocalMockAdyenId = (value: string | null | undefined, prefix: string): boolean =>
  value ? new RegExp(`^${prefix}-[0-9a-f-]{20,}$`, 'i').test(value) : false;

export const hasLocalMockAdyenAccountIds = (account: AdyenAccount | null): boolean =>
  Boolean(
    account &&
      (hasLocalMockAdyenId(account.adyenAccountHolderId, 'AH') ||
        hasLocalMockAdyenId(account.adyenLegalEntityId, 'LE') ||
        hasLocalMockAdyenId(account.adyenBalanceAccountId, 'BA') ||
        hasLocalMockAdyenId(account.transferInstrumentId, 'SE'))
  );

export interface AdyenKycDerived {
  requiredCapabilities: string[];
  validCapabilities: string[];
  hasLocalMockIds: boolean;
  payoutReady: boolean;
}

export const deriveAdyenKyc = (account: AdyenAccount | null): AdyenKycDerived => {
  const requiredCapabilities = account?.requiredCapabilities ?? [];
  const validCapabilities = requiredCapabilities.filter((capability) =>
    capabilityIsValid(account?.capabilities?.[capability])
  );
  const hasLocalMockIds = hasLocalMockAdyenAccountIds(account);
  const payoutReady =
    !hasLocalMockIds &&
    account?.payoutsAllowed === true &&
    requiredCapabilities.length > 0 &&
    validCapabilities.length === requiredCapabilities.length;
  return { requiredCapabilities, validCapabilities, hasLocalMockIds, payoutReady };
};
